if (!customElements.get('c-product-tabs-showcase')) {
  customElements.define(
    'c-product-tabs-showcase',
    class ProductTabsShowcase extends HTMLElement {
      connectedCallback() {
        this.slider = null;
        this.tabButtons = Array.from(this.querySelectorAll('[data-tab-button]'));
        this.slides = Array.from(this.querySelectorAll('[data-product-slide]'));
        this.carousel = this.querySelector('[data-product-carousel]');
        this.track = this.querySelector('[data-product-track]');

        this.handleTabClick = this.handleTabClick.bind(this);
        this.initSlider = this.initSlider.bind(this);

        this.tabButtons.forEach((button) => button.addEventListener('click', this.handleTabClick));

        const firstTab = this.tabButtons.find((button) => button.getAttribute('aria-selected') === 'true') || this.tabButtons[0];
        if (firstTab) this.activateTab(firstTab.dataset.tabButton);

        this.initSlider();
      }

      disconnectedCallback() {
        this.tabButtons.forEach((button) => button.removeEventListener('click', this.handleTabClick));
        this.destroySlider();
      }

      handleTabClick(event) {
        this.activateTab(event.currentTarget.dataset.tabButton);
      }

      normalizeSlug(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      activateTab(tabSlug) {
        const activeSlug = this.normalizeSlug(tabSlug);

        this.tabButtons.forEach((button) => {
          const isActive = this.normalizeSlug(button.dataset.tabButton) === activeSlug;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          button.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.slides.forEach((slide) => {
          const slideTabs = String(slide.dataset.productTabs || 'all')
            .split(/[\s,|;]+/)
            .map((slug) => this.normalizeSlug(slug))
            .filter(Boolean);
          const isVisible = slideTabs.includes(activeSlug) || slideTabs.includes('all');
          slide.hidden = !isVisible;
          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });

        this.refreshSlider();
      }

      initSlider() {
        if (this.slider || !this.carousel || !this.track) return;

        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          window.requestAnimationFrame(this.initSlider);
          return;
        }

        this.slider = new window.FoxTheme.Carousel(this.carousel, {
          slidesPerView: 1.35,
          spaceBetween: 8,
          breakpoints: {
            768: { slidesPerView: 2.35, spaceBetween: 16 },
            978: { slidesPerView: 3, spaceBetween: 24 },
            1200: { slidesPerView: 3, spaceBetween: 24 },
            1980: { slidesPerView: 3, spaceBetween: 24 },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          grabCursor: true,
          threshold: 2,
          loop: false,
          observer: true,
          observeParents: true,
        });
        this.slider.init();
        this.refreshSlider();
      }

      refreshSlider() {
        if (!this.slider || !this.slider.slider) return;
        window.requestAnimationFrame(() => {
          this.slider.slider.update();
          this.slider.slider.slideTo(0, 0);
        });
      }

      destroySlider() {
        if (!this.slider || !this.slider.slider) return;
        this.slider.slider.destroy(true, true);
        this.slider = null;
      }
    }
  );
}